import { render, staticRenderFns } from "./NewSigner.vue?vue&type=template&id=dec18f64&scoped=true"
import script from "./NewSigner.vue?vue&type=script&lang=js"
export * from "./NewSigner.vue?vue&type=script&lang=js"
import style0 from "./NewSigner.vue?vue&type=style&index=0&id=dec18f64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec18f64",
  null
  
)

export default component.exports